import { BaseService } from './_BaseService';

export class EnergyConsultantService extends BaseService {

    list = async () => {
        return await this.get(`energy-consultants`);
    }
}